import { View, Text, Image, Dimensions, TouchableOpacity } from "react-native";
import React, { useState } from "react";
import { danger, gray, primary, shadowSm, white } from "../../colors";
import MyText from "../custom/MyText";
import { doctorAvatar } from "../../imports";
import StepSlide from "../animation/StepSlide";
import MyButton from "../custom/MyButton";
import PersonIcon from "../../assets/svg/PersonIcon";
import translate from "../../functions/translate";
import { Feather } from "@expo/vector-icons";
import NoMoneyModal from "../modals/NoMoneyModal";
import { useDispatch } from "react-redux";
import { setNoMoneyModal } from "../../redux/modal/modalAction";
import requestConsultation from "../../api/consultation/requestConsultation";
import { useNavigation } from "@react-navigation/native";
import { currencyFormat } from "../../functions/functions";
import { Platform } from "react-native";

export default function ChatCard({
  name,
  lastName,
  image,
  suggested,
  price,
  consultationCount,
  id,
  childId,
  unreadCount,
  type,
}) {
  const navigation = useNavigation();
  const [mode, setMode] = useState(1);

  return (
    <TouchableOpacity
      onPress={() => navigation.navigate("Chat", { id: id, type: type })}
      style={{
        marginVertical: 5,
        width: "100%",
        ...shadowSm,
        padding: "1%",
        backgroundColor: "#F8F8F8",
        overflow: "hidden",
      }}
    >
      <View
        style={{
          flexDirection: "row",
          paddingVertical: 5,
          paddingHorizontal: 10,
        }}
      >
        <View>
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              padding: 2,
              width: 60,
              height: 60,
              borderRadius: 30,
              borderWidth: 1,
              borderColor: primary,
              overflow: "hidden",
            }}
          >
            <Image
              resizeMode="contain"
              source={{ uri: image }}
              defaultSource={doctorAvatar}
              style={{ width: 55, height: 55 }}
            />
          </View>
        </View>
        <View style={{ flex: 8, marginHorizontal: 10 }}>
          <MyText>{`${name} ${lastName}`}</MyText>
          <MyText style={{ fontSize: 13, color: gray, marginTop: 5 }}>
            {""}
          </MyText>
        </View>
        {unreadCount < 0 && (
          <View
            style={{
              padding: 3,
              justifyContent: "flex-end",
            }}
          >
            <View
              style={{
                backgroundColor: danger,
                justifyContent: "center",
                alignItems: "center",
                width: 30,
                height: 30,
                borderRadius: 20,
              }}
            >
              <MyText style={{ color: white }}>{`${unreadCount}`}</MyText>
            </View>
          </View>
        )}
      </View>
      <View style={{ height: 15 }}></View>
      <View
        style={{
          marginLeft: Platform.OS !== "web" ? "-4%" : 0,
          marginRight: Platform.OS === "web" ? "-4%" : 0,
        }}
      ></View>
    </TouchableOpacity>
  );
}
